<template>
  <div>
    <div>
      <defNavBar title="Ares - Show mail" download :info="[
          {label: 'Sent: ', value: mail.mail_dt},
          {label: 'Nr: ', value: mail.mail_nr},
          {label: 'Subject: ', value: mail.mail_subject},
          {label: 'Recipient: ', value: mail.mail_to}]" @actionClick="downloadMailAsFile" />
    </div>
    <v-main> 
      <v-container fluid>
        <div class="spinner">
          <v-row>
            <v-col cols="12" span="12" align="center">
              <v-progress-circular :width="3" :size="25" color="green" indeterminate></v-progress-circular>
              <span class="markup ml-4">loading...</span>
            </v-col>
          </v-row>  
        </div>
        <v-row>
          <v-col cols=12>
            <v-simple-table>
              <template v-slot:default>
               <tbody>
                <tr v-for="(mlat,i) in mail.mlat" :key="i" @click="showMlat(mlat.mlat_url)">
                 <td>{{mlat.mlat_filenaam}}</td>
                </tr>                  
               </tbody>  
              </template>  
            </v-simple-table>  
          </v-col>  
        </v-row>
        <v-row>
          <v-col cols=12>  
           <div v-html="mail.mail_tekst"></div>
          </v-col>         
        </v-row> 
      </v-container>
    </v-main>
  </div>
</template>


<script>
 import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    defNavBar
  },
  props: ['mail_encrid'],
  data() {
    return {
      loading: true,
      mail: {}
    }
    
  },
  mounted() {
    this.loading=true;
    this.$axios
      .post("ares/json/ares/misc/getMail.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getMail"
        },
        getMail: {
          mail_encrid: this.mail_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.mail = res.data.getMail;
           document.title = `${this.mail.mail_oms}`;
        }
      })
      .finally(() => {
        this.loading = false; 
        document.querySelector(".spinner").classList.add('d-none');
      });
  },
  methods: {
    downloadMailAsFile(){
      try{
        // let test = 'download'
        let fileContent = `${this.mail.mail_tekst}<br><br>Subject: ${this.mail.mail_subject}<br>Sent: ${this.mail.mail_dt}`;
        let fileBlob = new Blob([fileContent ], { type: 'text/plain' });
        let temp = document.createElement('a');
        temp.download = `${this.mail.mail_oms}.html`;
        temp.href = window.URL.createObjectURL(fileBlob);
        temp.click();
      } catch(err){
        console.log(err.message);
      }

    },
    showMlat(url) {
      window.open(url,'_blank');
    }
  }
};

</script> 
